export const DEFAULT_SETTINGS = {
    theme: 'light',
    dateFormat: 'MM-DD-YYYY',
    timezone: 'America/New_York',
    reportDeadlineDay: 2,
    reportDeadlineHour: 12,
    autoPublishReports: true,
    emailNotifications: true,
    reportReminders: true,
    reminderHoursBefore: 24,
    defaultShareExpiration: 7,
    allowPublicSharing: true,
    sessionTimeout: 60,
    rememberMe: true,
};

export const DAY_OPTIONS = [
    { value: 0, label: 'Sunday' },
    { value: 1, label: 'Monday' },
    { value: 2, label: 'Tuesday' },
    { value: 3, label: 'Wednesday' },
    { value: 4, label: 'Thursday' },
    { value: 5, label: 'Friday' },
    { value: 6, label: 'Saturday' },
];

export const HOUR_OPTIONS = Array.from({ length: 24 }, (_, i) => ({
    value: i,
    label: `${String(i).padStart(2, '0')}:00`,
}));

export const TIMEZONE_OPTIONS = [
    { value: 'America/New_York', label: 'Eastern Time (ET)' },
    { value: 'America/Chicago', label: 'Central Time (CT)' },
    { value: 'America/Denver', label: 'Mountain Time (MT)' },
    { value: 'America/Los_Angeles', label: 'Pacific Time (PT)' },
    { value: 'UTC', label: 'UTC' },
];

export const DATE_FORMAT_OPTIONS = [
    { value: 'MM-DD-YYYY', label: 'MM-DD-YYYY' },
    { value: 'DD-MM-YYYY', label: 'DD-MM-YYYY' },
    { value: 'YYYY-MM-DD', label: 'YYYY-MM-DD' },
];

export const EXPIRATION_OPTIONS = [
    { value: 1, label: '1 Day' },
    { value: 7, label: '1 Week' },
    { value: 14, label: '2 Weeks' },
    { value: 30, label: '1 Month' },
    { value: 0, label: 'Never' },
];
